import React, { useRef, useState, useEffect } from 'react';
import './nft.css';
import { motion } from 'framer-motion';

const leftVariant = {
    hidden: {
        y: "15vh",
        opacity: 0
    },
    visible: {
        y: 0,
        x: 0,
        opacity: 1,
        transition: {
            delay: 0.3,
            duration: 1
        }
    }
};

const rightVariant = {
    hidden: {
        y: "15vh",
        opacity: 0
    },
    visible: {
        y: 0,
        x: 0,
        opacity: 1,
        transition: {
            delay: 0.3,
            duration: 1
        }
    }
};

export default function Nft() {
    const [isNftCardVisible, setIsNftCardVisible] = useState(false);
    const nftCardRefs = useRef([]);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setIsNftCardVisible(true);
                } else {
                    setIsNftCardVisible(false);
                }
            });
        }, {
            threshold: 0.5
        });

        nftCardRefs.current.forEach((ref) => {
            if (ref) observer.observe(ref);
        });

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <div className='nft-section'>
            <div className="nft-header"
            >
                <h3>Upgrade your web3 identity </h3>
                <p>Modern cryptocurrency shouldn't be boring, user must be allowed to express their creativity and break free from standardization.</p>
            </div>
            <div className="nft-body">
                <motion.div
                    className="nft-card"
                    variants={leftVariant}
                    initial="hidden"
                    animate={isNftCardVisible ? "visible" : "hidden"}
                    ref={(el) => nftCardRefs.current[1] = el}
                >
                    <div className="nft-card-header">
                        <p>$APPL</p>
                    </div>
                    <div className="card-image">
                        <img src="assets/nft/realistic_3d_microsoft_logo_using_this_color_e0ffff-removebg-preview.png" alt="" />
                    </div>
                    <div className="card-body">
                        <p>Apple</p>
                    </div>
                </motion.div>
                <div className="nft-card">
                    <div className="nft-card-header">
                        <p>$MSFT</p>
                    </div>
                    <div className="card-image">
                        <img src="assets/nft/realistic_3d_google_logo_using_this_color_e0ffff-removebg-preview.png" alt="" />
                    </div>
                    <div className="card-body">
                        <p>Microsoft</p>
                    </div>
                </div>
                <motion.div
                    className="nft-card"
                    variants={rightVariant}
                    initial="hidden"
                    animate={isNftCardVisible ? "visible" : "hidden"}
                    ref={(el) => nftCardRefs.current[2] = el}
                >
                    <div className="nft-card-header">
                        <p>$GGL</p>
                    </div>
                    <div className="card-image">
                        <img src="assets/nft/3d_apple_logo_using_this_color_e0ffff-removebg-preview.png" alt="" />
                    </div>
                    <div className="card-body">
                        <p>Google</p>
                    </div>
                </motion.div>
            </div>
        </div>
    );
}